import React from 'react';
import { Progress } from 'antd';
import './CustomerSatisfactionAnalytics.less';

// catering
// housekeeping
// medicalTeam
// nursingCare
// overallSatisfaction
// postpartumCare
// salesCustomerService
// security
const scoreDetailsConfig = [
  { key: 'catering', value: '餐饮部'},
  { key: 'housekeeping', value: '客房部'},
  { key: 'medicalTeam', value: '医疗团队'},
  { key: 'nursingCare', value: '护理部'},
  // { key: 'overallSatisfaction', value: '整体满意度'},
  { key: 'postpartumCare', value: '产康部'},
  { key: 'salesCustomerService', value: '客服部'},
  { key: 'security', value: '安保部'}
]
class CustomerSatisfactionAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      satisfactionScore: 95, // 默认95，可以从props获取
      currentScoreIndex: 0, // 当前显示的分数索引
      containerWidth: 0, // 容器宽度
      displayCount: 1 // 根据宽度计算的显示数量
    };
    this.rotationInterval = null;
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.startRotation();
    // 使用setTimeout确保DOM已渲染
    setTimeout(() => {
      this.updateContainerWidth();
      this.resizeObserver = new ResizeObserver(() => {
        this.updateContainerWidth();
      });
      if (this.containerRef.current) {
        this.resizeObserver.observe(this.containerRef.current);
      }
    }, 0);
  }

  componentWillUnmount() {
    this.stopRotation();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  updateContainerWidth = () => {
    if (this.containerRef.current) {
      const width = this.containerRef.current.offsetWidth;
      // 获取有效的配置项数量
      const { customerSatisfactionObj = {} } = this.props;
      const { data: satisfactionScoreDetails } = customerSatisfactionObj;
      const validConfigs = scoreDetailsConfig.filter(config => 
        satisfactionScoreDetails && satisfactionScoreDetails[config.key] !== undefined
      );
      
      if (validConfigs.length === 0) {
        this.setState({ 
          containerWidth: width,
          displayCount: 0
        });
        return;
      }
      
      // 根据宽度计算可以显示的分数数量
      // 每个分数项内容宽度约70-100px（根据文字长度），间距约16px（gap）
      // 使用更保守的估算，确保不会溢出
      const avgItemWidth = 85; // 平均项宽度
      const gapWidth = 16; // 每个项之间的间距
      const padding = 32; // 容器内边距（左右各16px）
      const availableWidth = width - padding;
      
      // 使用平均宽度计算，但保守一些
      const calculatedCount = Math.max(1, Math.floor((availableWidth + gapWidth) / (avgItemWidth + gapWidth)));
      
      // 最多显示所有有效的配置项，但至少显示1个
      const displayCount = Math.min(calculatedCount, validConfigs.length);
      
      this.setState({ 
        containerWidth: width,
        displayCount: displayCount
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { customerSatisfactionObj = {} } = this.props;
    const { data: satisfactionScoreDetails } = customerSatisfactionObj;
    const prevData = prevProps.customerSatisfactionObj?.data || {};
    
    // 如果数据发生变化，重新开始轮动并更新宽度
    if (satisfactionScoreDetails !== prevData) {
      this.stopRotation();
      this.startRotation();
      this.updateContainerWidth();
    }
  }

  startRotation = () => {
    const { customerSatisfactionObj = {} } = this.props;
    const { data: satisfactionScoreDetails } = customerSatisfactionObj;
    
    if (!satisfactionScoreDetails || Object.keys(satisfactionScoreDetails).length === 0) {
      return;
    }

    // 每3秒切换一次
    this.rotationInterval = setInterval(() => {
      this.setState(prevState => {
        const validConfigs = scoreDetailsConfig.filter(config => 
          satisfactionScoreDetails[config.key] !== undefined
        );
        if (validConfigs.length === 0) return prevState;
        
        return {
          currentScoreIndex: (prevState.currentScoreIndex + 1) % validConfigs.length
        };
      });
    }, 3000);
  }

  stopRotation = () => {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval);
      this.rotationInterval = null;
    }
  }

  render() {
    const { customerSatisfactionObj = {} } = this.props;
    const { data: satisfactionScoreDetails } = customerSatisfactionObj;
    const { satisfactionScore, currentScoreIndex, displayCount } = this.state;
    const totalSegments = 20;
    const filledSegments = Math.round((satisfactionScoreDetails.overallSatisfaction / 100) * totalSegments);

    // 获取有效的配置项（数据中存在的）
    const validConfigs = scoreDetailsConfig.filter(config => 
      satisfactionScoreDetails && satisfactionScoreDetails[config.key] !== undefined
    );
    
    // 根据displayCount获取要显示的分数信息
    // 如果displayCount >= validConfigs.length，显示所有项；否则按轮播显示
    const displayConfigs = [];
    if (validConfigs.length > 0) {
      if (displayCount >= validConfigs.length) {
        // 如果容器足够宽，显示所有项
        displayConfigs.push(...validConfigs);
      } else {
        // 否则按轮播显示指定数量
        for (let i = 0; i < displayCount; i++) {
          const index = (currentScoreIndex + i) % validConfigs.length;
          displayConfigs.push(validConfigs[index]);
        }
      }
    }
    
  
    return (
      <div className="customer-satisfaction-analytics" ref={this.containerRef}>
        <div className="customer-satisfaction-header">
          <div className="customer-satisfaction-title">客户满意度</div>
          <div className="customer-satisfaction-score">{satisfactionScoreDetails.overallSatisfaction}</div>
        </div>
        <div className="customer-satisfaction-progress-container">
          <Progress
            percent={satisfactionScoreDetails.overallSatisfaction}
            strokeColor="#2ECC71"
            trailColor="#D4EFDF"
            showInfo={false}
            className="customer-satisfaction-progress"
          />
          <div className="customer-satisfaction-segments-overlay">
            {Array.from({ length: totalSegments }, (_, index) => (
              <div
                key={index}
                className={`customer-satisfaction-segment ${
                  index < filledSegments ? 'filled' : 'unfilled'
                }`}
              />
            ))}
          </div>
        </div>
        <div className="customer-satisfaction-score-details">
          {displayConfigs.map((config, index) => {
            const score = satisfactionScoreDetails && satisfactionScoreDetails[config.key];
            return score !== null && score !== undefined ? (
              <div key={config.key} className="score-detail-item">
                <span className="score-detail-label">{config.value}:</span>
                <span className="score-detail-value">{score}</span>
              </div>
            ) : null;
          })}
        </div>
      </div>
    );
  }
}

export default CustomerSatisfactionAnalytics;

